import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-delivery-order-detail',
  standalone: false,
  
  templateUrl: './daily-delivery-order-detail.component.html',
  styles: ``
})
export class DailyDeliveryOrderDetailComponent {

}
